/**
 * Tracker id ↔ DB enum conversions, and parsing of untrusted values.
 * For Media Devoted | Created By Ciro Autiero
 *
 * Parsers return null for anything unknown — callers decide what that means.
 * Nothing here "defaults to Voluum" except legacy bank rows whose `platform`
 * is NULL (written before Binom existed, so they are Voluum by construction).
 */

import {
  TRACKER_ENUMS,
  TRACKER_IDS,
  TRACKERS,
  type TrackerEnum,
  type TrackerId,
} from './tracker-registry';

const ID_BY_ENUM: Readonly<Record<TrackerEnum, TrackerId>> = {
  VOLUUM: 'voluum',
  BINOM: 'binom',
  TRES_COMMAS: 'tres-commas',
};

export function trackerFromEnum(value: TrackerEnum): TrackerId {
  return ID_BY_ENUM[value];
}

export function trackerEnum(id: TrackerId): TrackerEnum {
  return TRACKERS[id].enumValue;
}

export function parseTrackerId(value: unknown): TrackerId | null {
  return (TRACKER_IDS as readonly unknown[]).includes(value) ? (value as TrackerId) : null;
}

export function parseTrackerEnum(value: unknown): TrackerEnum | null {
  return (TRACKER_ENUMS as readonly unknown[]).includes(value) ? (value as TrackerEnum) : null;
}

/** Bank-row `platform`: NULL/undefined = legacy Voluum row; unknown text = null. */
export function trackerFromPlatform(platform: string | null | undefined): TrackerId | null {
  if (platform == null) return 'voluum';
  return parseTrackerId(platform);
}

export function trackerLabel(id: TrackerId): string {
  return TRACKERS[id].label;
}
